import React, { memo, useEffect, useState } from "react";

// ClassNames
import clsx from "clsx";

// Components
import Img from "components/Img";

// Type
import { AvatarType } from "./type";

const DefaultUserView: React.FC<AvatarType> = (props) => {
  const {
    name,
    title,
    email,
    avatar,
    isMenu,
    lastName,
    isShowName
  } = props;
  const [result, setResult] = useState<string | null>("");

  useEffect(() => {
    if (avatar instanceof Blob) {
      const objectUrl = URL.createObjectURL(avatar);
      setResult(objectUrl);

      // Clean up the object URL when the component is unmounted or when `avatar` changes
      return () => URL.revokeObjectURL(objectUrl);
    } else {
      setResult(null);
    }
  }, [avatar]);

  if (!avatar) return null;

  const cnFullName = clsx(
    "wrapper-avatar__name",
    isMenu ? "wrapper-avatar__menu" : ""
  );

  return <div className="flex flex-ai-center">
    <Img
      isPreloader
      alt="Avatar user"
      className="avatar"
      innerSrc={result as string}
    />
    {isShowName &&
      <div className="flex flex-ai-start flex-direction-column">
        {<p className={cnFullName}>
          {title ? `${title}.` : ""} {lastName} {name ? `${name}` : ""}
        </p>}
        {isMenu &&
          <p className="wrapper-avatar__email">
            {email}
          </p>}
      </div>}
  </div>;
};

const NameUserView: React.FC<AvatarType> = (props) => {
  const { name, isMenu, email, title, lastName, isShowName } = props;

  const cnName = clsx(
    "wrapper-avatar__avatar flex flex-jc-center flex-ai-center",
    name ? "wrapper-avatar__avatar--active" : ""
  );

  const cnFullName = clsx(
    "wrapper-avatar__name",
    isMenu ? "wrapper-avatar__menu" : ""
  );

  return (
    <div className="flex flex-ai-center">
      <div className={cnName}>
        {!!name && name[0].toUpperCase()}
      </div>
      {isShowName &&
        <div className="flex flex-ai-start flex-direction-column">
          {<p className={cnFullName}>
            {title ? `${title}.` : ""} {lastName} {name ? `${name}` : ""}
          </p>}
          {isMenu &&
            <p className="wrapper-avatar__email">
              {email}
            </p>}
        </div>}
    </div>
  );
};

const NameUserEmpty: React.FC<AvatarType> = (props) => {
  const { onClick, isClose, className } = props;
  const cn = clsx(
    "wrapper-avatar flex-ai-center flex-jc-center",
    className ? className : ""
  );

  return (
    <div
      className={cn}
      onClick={onClick}
    >
      {isClose ?
        <Img
          isSvg
          alt="Avatar"
          name="crossSvg"
          className="wrapper-avatar__cross"
        />
        :
        <Img
          isSvg
          name="userSvg"
          alt="Default user avatar"
          className="wrapper-avatar__avatar"
        />}
    </div>
  );
};

const Avatar: React.FC<AvatarType> = (props) => {
  const {
    name,
    title,
    email,
    isMenu,
    avatar,
    isClose,
    onClick,
    lastName,
    className,
    isShowName
  } = props;

  const [showAvatar, setShowAvatar] = useState<boolean>(!!avatar);

  useEffect(() => {
    setShowAvatar(!!avatar);
  }, [avatar]);

  if (showAvatar) {
    return <DefaultUserView {...{
      name,
      title,
      email,
      avatar,
      isMenu,
      lastName,
      isShowName
    }} />;
  }

  if (name) {
    return <NameUserView {...{
      name,
      title,
      email,
      isMenu,
      lastName,
      className,
      isShowName
    }} />;
  }

  return <NameUserEmpty {...{ onClick, isClose, className, setShowAvatar }} />;
};

export default memo(Avatar);
